import React from 'react';
import { Row, Col, Card, Statistic, Skeleton } from 'antd';
import { COLOR_PRIMARY, COLOR_SUCCESS, COLOR_WARNING } from '../../utils/colors';

const JobStatsCards = ({ loading, stats }) => (
  <Row gutter={[16, 16]}>
    <Col span={6}>
      <Card style={{ borderTop: `3px solid ${COLOR_PRIMARY}` }}>
        <Skeleton loading={loading} active paragraph={{ rows: 1 }}>
          <Statistic title="Total Jobs (All)" value={stats.totalJobs} />
        </Skeleton>
      </Card>
    </Col>
    <Col span={6}>
      <Card style={{ borderTop: '3px solid #722ed1' }}>
        <Skeleton loading={loading} active paragraph={{ rows: 1 }}>
          <Statistic title="Filtered Jobs" value={stats.filteredJobs} />
        </Skeleton>
      </Card>
    </Col>
    <Col span={6}>
      <Card style={{ borderTop: `3px solid ${COLOR_SUCCESS}` }}>
        <Skeleton loading={loading} active paragraph={{ rows: 1 }}>
          <Statistic title="Completed Jobs (Filtered)" value={stats.completedJobs} valueStyle={{ color: COLOR_SUCCESS }} />
        </Skeleton>
      </Card>
    </Col>
    <Col span={6}>
      <Card style={{ borderTop: `3px solid ${COLOR_WARNING}` }}>
        <Skeleton loading={loading} active paragraph={{ rows: 1 }}>
          <Statistic title="Unassigned Jobs (Filtered)" value={stats.unassignedJobs} valueStyle={{ color: COLOR_WARNING }} />
        </Skeleton>
      </Card>
    </Col>
  </Row>
);

export default JobStatsCards;
